export const normalizeTicketPromotion = (input = {}) => {
  const source = input?.promotion || input || {};
  const enabled =
    source.enabled === true ||
    source.enabled === "true" ||
    source.enabled === 1 ||
    source.enabled === "1";
  const ticketsRequired = Math.max(
    0,
    Math.trunc(
      Number(
        source.ticketsRequired ??
          source.requiredQuantity ??
          source.quantityRequired ??
          source.packQuantity ??
          source.buy ??
          source.required ??
          0
      )
    )
  );
  const ticketsCharged = Math.max(
    0,
    Math.trunc(
      Number(
        source.ticketsCharged ??
          source.chargedQuantity ??
          source.quantityCharged ??
          source.payQuantity ??
          source.pay ??
          source.charged ??
          0
      )
    )
  );

  if (!enabled || ticketsRequired < 2 || ticketsCharged < 1 || ticketsCharged >= ticketsRequired) {
    return { enabled: false, ticketsRequired: 0, ticketsCharged: 0, label: "" };
  }

  return {
    enabled: true,
    ticketsRequired,
    ticketsCharged,
    label: String(source.label || `${ticketsRequired}x${ticketsCharged}`).trim(),
  };
};

export const calculateChargedQuantity = (quantity, promotion) => {
  const qty = Math.max(0, Math.trunc(Number(quantity || 0)));
  const promo = normalizeTicketPromotion(promotion);
  if (!promo.enabled || qty <= 0) return qty;
  const packs = Math.floor(qty / promo.ticketsRequired);
  const remainder = qty % promo.ticketsRequired;
  return packs * promo.ticketsCharged + remainder;
};

export const calculateTicketLineTotal = (unitPrice, quantity, promotion) => {
  const price = Number(unitPrice || 0);
  const chargedQty = calculateChargedQuantity(quantity, promotion);
  return Math.round(price * chargedQty * 100) / 100;
};

export const getPromotionLabel = (promotion) => {
  const promo = normalizeTicketPromotion(promotion);
  return promo.enabled ? `Promo ${promo.label || `${promo.ticketsRequired}x${promo.ticketsCharged}`}` : "";
};
